import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router';
import { registerSW } from 'virtual:pwa-register';
import RootLayout from './layout';
import MainPage from './page';
import ReferralRedirect from './components/auth/ReferralRedirect';
import WheelLayout from './[wheelId]/layout';
import WheelPage from './[wheelId]/page';
import RolesPage from './[wheelId]/roles/page';
import LifePartDetailPage from './[wheelId]/roles/[lifePartUuid]/page';
import GoalsPage from './[wheelId]/goals/page';
import GrowthPage from './[wheelId]/growth/page';
import SharedTrackersPage from './[wheelId]/growth/shared';
import PlanPage from './[wheelId]/plan/page';
import ActionsPage from './[wheelId]/actions/page';
import ListsPage from './[wheelId]/lists/page';
import SummaryPage from './[wheelId]/summary/page';
import TariffsPage from './[wheelId]/tariffs/page';
import ReflectionPage from './[wheelId]/reflection/page';
import ReflectionCreatePage from './[wheelId]/reflection/create';
import ReflectionViewPage from './[wheelId]/reflection/[reflectionUuid]/page';
import PublicTrackerPage from './shared/trackers/[slug]/page';
import NotFound from './[wheelId]/not-found';
import PrivacyPage from './privacy/page';
import TermsPage from './terms/page';
import RefundPage from './refund/page';
import CookiePolicyPage from './cookie-policy/page';
import './globals.css';
import { setupExternalLinksHandler } from './utils/externalLinks';

// Регистрация глобального обработчика внешних ссылок
// В PWA standalone-режиме перехватывает клики по внешним ссылкам
// и открывает их в системном браузере
if (typeof window !== 'undefined') {
  setupExternalLinksHandler();
}

// Регистрация Service Worker с ручным подтверждением обновления
const updateSW = registerSW({
  onNeedRefresh() {
    window.onNeedRefresh?.();
  },
  onOfflineReady() {
    console.log('Приложение готово к работе офлайн');
  },
});

window.__updateSW = updateSW;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="r/:refKey" element={<ReferralRedirect />} />
        <Route path="/" element={<RootLayout />}>
          <Route index element={<MainPage />} />
          <Route path=":wheelId" element={<WheelLayout />}>
            <Route index element={<WheelPage />} />
            <Route path="roles" element={<RolesPage />} />
            <Route path="roles/:lifePartUuid" element={<LifePartDetailPage />} />
            <Route path="goals" element={<GoalsPage />} />
            <Route path="growth" element={<GrowthPage />} />
            <Route path="growth/shared" element={<SharedTrackersPage />} />
            <Route path="plan" element={<PlanPage />} />
            <Route path="actions" element={<ActionsPage />} />
            <Route path="lists" element={<ListsPage />} />
            <Route path="summary" element={<SummaryPage />} />
            <Route path="tariffs" element={<TariffsPage />} />
            <Route path="reflection" element={<ReflectionPage />} />
            <Route path="reflection/create" element={<ReflectionCreatePage />} />
            <Route path="reflection/:reflectionUuid" element={<ReflectionViewPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
        <Route path="shared/trackers/:slug" element={<PublicTrackerPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="refund" element={<RefundPage />} />
        <Route path="cookie-policy" element={<CookiePolicyPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);